import * as React from "react";
import * as _ from "lodash";
import { connect } from "react-redux";
import { IStore } from "../../../redux/initialState";

const GIT_AUTH_DOMAIN = process.env.GIT_AUTH_DOMAIN;

function GitHubIntegrationWrapper({ children, githubFeatureAvailable }) {
  if (githubFeatureAvailable) {
    if (
      GIT_AUTH_DOMAIN &&
      _.isString(GIT_AUTH_DOMAIN) &&
      GIT_AUTH_DOMAIN.indexOf("$TUTOR") === -1
    ) {
      return <>{children}</>;
    } else {
      console.warn(
        "Specifiy GitHub auth domain in env variables for integration with GitHub"
      );
      return <></>;
    }
  }

  return <></>;
}

function mapStateToProps({ config }: IStore) {
  return {
    githubFeatureAvailable: config?.features?.github?.enabled === true && config?.features?.github?.codeSync?.enabled === true,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GitHubIntegrationWrapper);
